import { useEffect, useState } from "react";
import { askGet } from "../utils/ask/askRequest";

const POLL_MS = 800;

/**
 * The step the server is on for the question in flight ("Reading the file",
 * "Checking Missions", "Writing the answer"), polled from
 * GET ai/chats/progress/:requestId while there is a request id. The last step
 * seen stays until the id changes, so the line never flips back to blank.
 * @param requestId - The in-flight question's id, or null when nothing is asked.
 * @returns The latest step, or null.
 */
export const useAskProgress = (requestId: string | null): string | null => {
    const [step, setStep] = useState<string | null>(null);
    useEffect(() => {
        setStep(null);
        if (!requestId) return;
        let isLive = true;
        const poll = async () => {
            const response = await askGet<{ step: string | null }>(`ai/chats/progress/${requestId}`).catch(() => null);
            if (isLive && response?.status === 200 && response.body?.step) setStep(response.body.step);
        };
        poll();
        const timer = window.setInterval(poll, POLL_MS);
        return () => {
            isLive = false;
            window.clearInterval(timer);
        };
    }, [requestId]);
    return step;
};
